import React from 'react';
import * as Yup from 'yup';

import AddAccountFormContainer from '../../AddAccountFormContainer';
import CurrencyInput from 'src/components/formik-fields/currency-input/CurrencyInput';
import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import {
    AddAccountFormViewModel,
    VehicleAndOtherAddAccountViewModel
} from 'src/types/view-models/addAccount/addAccount.view.model';
import LiteralsService from 'src/services/literals/LiteralsService';
import { InvestmentHoldingType } from 'src/types/investment-holding.model';
import Card from 'src/components/atomic/atoms/card/Card';
import { IconInfo } from '@americanexpress/dls-react';
import styles from './customPropertyAndAssetsForm.module.scss';
import bgColors from 'src/styles/bgColors.module.scss';
import { DLSSize } from 'src/types/dls-size.enum';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import PercentSlider from 'src/components/formik-fields/percent-slider/PercentSlider';
import UtilsService from 'src/services/utils.service';

export default function CustomPropertyAndAssetsForm({
    manualAccount,
    onSubmit,
    handleBack
}: AddAccountFormViewModel): JSX.Element {
    const handleSubmit = (values: VehicleAndOtherAddAccountViewModel): void => {
        const formattedInterest: number = values.interest / 100;

        const updatedValues = {
            ...values,
            interest: formattedInterest
        };
        void onSubmit(updatedValues, manualAccount, false, InvestmentHoldingType.Custom);
    };
    return (
        <AddAccountFormContainer
            initialValues={{
                name: manualAccount?.investmentHolding?.name,
                amount: manualAccount?.investmentHolding?.amount,
                interest: UtilsService.convertInterest(manualAccount?.investmentHolding?.interest) || 0
            }}
            validationSchema={Yup.object({
                name: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                amount: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                interest: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
            })}
            manualAccount={manualAccount}
            onSubmit={(values) => handleSubmit(values)}
            handleBack={handleBack}
        >
            <BasicInput id="name" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.name')} />
            <CurrencyInput
                id="amount"
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.currentValue')}
            />
            <PercentSlider
                id="interest"
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.annualGrowthRate')}
                min={-25}
                max={25}
            />
            <Card
                className={`${styles.info} ${bgColors.neutralWeak}`}
                icon={<IconInfo size={DLSSize.MEDIUM} />}
                heading={
                    <Typography variant={TypographyVariants.SUBTEXT}>
                        {LiteralsService.getLiteral('Onboarding.forms.inputHints.infoCallout')}
                    </Typography>
                }
            >
                <></>
            </Card>
        </AddAccountFormContainer>
    );
}
